<ui-assignee-avatar [uiAssignee]="assignee" [uiSize]="size" [uiShowTooltip]="showTooltip"></ui-assignee-avatar>
<gh-full-name [ghFullNameSettings]="fullNameSettings" [ghFullNameEntity]="assignee"></gh-full-name>
